import { combineReducers } from "redux";
import {
  PERMOHONAN_HSCODE_APPROVE_ERROR,
  PERMOHONAN_HSCODE_APPROVE_LOADING,
  PERMOHONAN_HSCODE_APPROVE_SUCCESS,
  PERMOHONAN_HSCODE_GET_ERROR,
  PERMOHONAN_HSCODE_GET_LOADING,
  PERMOHONAN_HSCODE_GET_SUCCESS,
  PERMOHONAN_HSCODE_REJECT_ERROR,
  PERMOHONAN_HSCODE_REJECT_LOADING,
  PERMOHONAN_HSCODE_REJECT_SUCCESS,
  PERMOHONAN_HSCODE_VIEW_ERROR,
  PERMOHONAN_HSCODE_VIEW_LOADING,
  PERMOHONAN_HSCODE_VIEW_SUCCESS,
} from "../actions/constant";

const permohonanHscodeGetError = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_GET_ERROR:
      return action.permohonanHscodeGetError;
    default:
      return state;
  }
};
const permohonanHscodeGetLoading = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_GET_LOADING:
      return action.permohonanHscodeGetLoading;
    default:
      return state;
  }
};
const permohonanHscodeGetSuccess = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_GET_SUCCESS:
      return action.permohonanHscodeGetSuccess;
    default:
      return state;
  }
};

const hscode = (state = [], action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_GET_SUCCESS:
      return action.hscode;
    default:
      return state;
  }
};

const permohonanHscodeViewError = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_VIEW_ERROR:
      return action.permohonanHscodeViewError;
    default:
      return state;
  }
};

const permohonanHscodeViewLoading = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_VIEW_LOADING:
      return action.permohonanHscodeViewLoading;
    default:
      return state;
  }
};

const permohonanHscodeViewSuccess = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_VIEW_SUCCESS:
      return action.permohonanHscodeViewSuccess;
    default:
      return state;
  }
};

const hscodes = (state = [], action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_VIEW_SUCCESS:
      return action.hscodes;
    default:
      return state;
  }
};

const permohonanHscodeApproveError = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_APPROVE_ERROR:
      return action.permohonanHscodeApproveError;
    default:
      return state;
  }
};

const permohonanHscodeApproveLoading = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_APPROVE_LOADING:
      return action.permohonanHscodeApproveLoading;
    default:
      return state;
  }
};

const permohonanHscodeApproveSuccess = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_APPROVE_SUCCESS:
      return action.permohonanHscodeApproveSuccess;
    default:
      return state;
  }
};

const permohonanHscodeRejectError = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_REJECT_ERROR:
      return action.permohonanHscodeRejectError;
    default:
      return state;
  }
};

const permohonanHscodeRejectLoading = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_REJECT_LOADING:
      return action.permohonanHscodeRejectLoading;
    default:
      return state;
  }
};

const permohonanHscodeRejectSuccess = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_HSCODE_REJECT_SUCCESS:
      return action.permohonanHscodeRejectSuccess;
    default:
      return state;
  }
};

const permohonanHscodeReducer = combineReducers({
  permohonanHscodeGetError,
  permohonanHscodeGetLoading,
  permohonanHscodeGetSuccess,
  hscode,

  permohonanHscodeViewError,
  permohonanHscodeViewLoading,
  permohonanHscodeViewSuccess,
  hscodes,

  permohonanHscodeApproveError,
  permohonanHscodeApproveLoading,
  permohonanHscodeApproveSuccess,

  permohonanHscodeRejectError,
  permohonanHscodeRejectLoading,
  permohonanHscodeRejectSuccess,
});

export default permohonanHscodeReducer;
